import { type ServicePointNotificationResponse, useGetServicePointNotification } from '@dhl/receiver-preference-api'

// Keep in sync with the notification types NewServicePointInteraction renders a modal for.
const supportedNotificationTypes: ServicePointNotificationResponse['notificationType'][] = [
  'closer-than-preference',
  'new-in-area',
]

export const useNewServicePointInteraction = () => {
  const { refetch: getServicePointNotifications } = useGetServicePointNotification({
    query: {
      // Do not execute the React Query call by default when the page loads
      enabled: false,
    },
  })

  return async (): Promise<boolean> => {
    try {
      const { isSuccess, data } = await getServicePointNotifications()

      return isSuccess && !!data?.servicePointId && supportedNotificationTypes.includes(data.notificationType)
    } catch {
      return false
    }
  }
}
